export const DIVIDEND_RATE_IS_REQUIRED_FEEDBACK = 'Dividend Rate is required.';
export const COMPOUNDING_PERIOD_IS_REQUIRED_FEEDBACK = 'Compounding Period is required.';
export const COMPOUNDING_PERIOD_MIN_VALUE_FEEDBACK = 'Compounding Period must be 1 or greater.';
export const PREVIOUS_EFFECTIVE_DATE_FEEDBACK = 'Effective date must be greater than the previous effective date';
export const MIN_EFFECTIVE_DATE_FEEDBACK = 'First effective date must be equal to the investment date';
export const INVESTMENT_DATE_NOT_DEFINED_FEEDBACK = 'Investment date is not defined';
export const SELECT_VALID_LIQUIDATION_PRIORITY = 'Please select the liquidation priority.';
